import React, { useContext, Fragment } from "react";

import { EligibilityContext } from "../../../contexts/EligibilityContext";

const ContactUs = () => {
  const context = useContext(EligibilityContext);

  const handleLink = () => {
    context.actions.closeModal();
  };

  return (
    <Fragment>
      <p className="f-h4 c-purple u-mb1">Contact us for additional help</p>
      <p>We can help you connect to other organizations and services.</p>
      <p style={{ marginBottom: 0 }}>
        <a className="btn" href="/contact" onClick={handleLink}>Contact us</a>
      </p>
    </Fragment>
  );
};

export default ContactUs;
